import { Component, Input, OnInit } from '@angular/core';
import { FooterService } from '@app/member-response-portal/service/footer.service';
import { Router } from '@angular/router';
import { PHONE_NUMBER } from '@app/member-response-portal/model/constants';
import { Helper } from '@rawlings/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    //#region Inputs, Outputs, ViewChilds
    @Input() public ShowHeader: boolean = true;
    //#endregion Inputs, Outputs, ViewChilds

    //#region Public Variables
    public CurrentDate: Date = new Date();
    public HideFooterText : boolean = false;
    public PageRestrictedFootertext : string[] = ['login', 'confirmhealthinsurance', 'contactinformation', 'confirmation'];
    public PhoneNumber: string = '';
    //#endregion Public Variables

    //#region Private Variables
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor and Angular Life Cycle
    constructor(
        private dialogService: FooterService,
        private router : Router
    ){
      this.CheckCurrentRoute();
    }

    public ngOnInit(): void {
        // eslint-disable-next-line @typescript-eslint/typedef
        const cachePhoneNumber = localStorage.getItem(PHONE_NUMBER);

        if (!Helper.IsEmpty(cachePhoneNumber)){
            this.PhoneNumber = cachePhoneNumber;
        }
    }


    //#endregion Constructor and Angular Life Cycle

    //#region Event Handlers
    //#endregion Event Handlers

    //#region Public Methods
    public OnClickContactUs(): void {
        this.dialogService.OpenContactUs();
    }

    public OnClickFaq(): void {
        this.dialogService.OpenFaq();
    }

    public OnClickLanguageAccesibility(): void {
        this.dialogService.OpenLanguageAccesibility();
    }

    public OnClickWhoWeAre(): void {
        this.dialogService.OpenWhoWeAre();
    }

    public OnClickPrivacyPolicy():void {
        this.dialogService.OpenPrivacyPolicy();
    }
    //#endregion Public Methods

    //#region Private Methods
    private CheckCurrentRoute() : void{
        this.router.events.subscribe(()=> {
            this.HideFooterText = !this.PageRestrictedFootertext.some((page:string) => this.router.url.includes(page));
        })
    }
    //#endregion Private Methods
}
